import { render, staticRenderFns } from "./PortForwardingList.vue?vue&type=template&id=9d93675a&"
import script from "./PortForwardingList.vue?vue&type=script&lang=js&"
export * from "./PortForwardingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports